<template>
    <div class="page_content">
        <!-- 顶部布局：左侧查询，右侧配置 -->
        <div class="top-layout">
            <!-- 左侧查询区域 -->
            <div class="left-section">
                <div class="card search-card">
                    <div class="card-header">
                        <h3>查询条件</h3>
                    </div>
                    <div class="card-body">
                        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                        </v-search>
                    </div>
                </div>
            </div>

            <!-- 右侧配置区域 -->
            <div class="right-section">
                <div class="card config-card">
                    <div class="card-header">
                        <h3>打印配置</h3>
                    </div>
                    <div class="card-body">
                        <!-- 模板设计按钮 -->
                        <div class="button-group">
                            <el-button :disabled="disabled" size="small" type="primary" @click="showPrintPlan">打印模版设计</el-button>
                            <el-button size="small" type="primary" @click="openFormDesign">自定义设计</el-button>
                        </div>

                        <!-- 打印模板选择 -->
                        <div class="form-group">
                            <label class="form-label">
                                打印模版:
                                <span class="selected-templates" v-if="selectPrint.length > 0">{{ printData.filter(item => selectPrint.includes(item.printId)).map(item => item.printName).join('、') }}</span>
                            </label>
                            <el-select :disabled="disabled" style="width: 100%" v-model="selectPrint" multiple collapse-tags placeholder="请选择">
                                <el-option v-for="item in printData" :key="item.printId" :label="item.printName" :value="item.printId">
                                </el-option>
                            </el-select>
                        </div>

                        <!-- 打印频率设置 -->
                        <div class="form-group">
                            <label class="form-label">打印频率：</label>
                            <el-input :disabled="disabled" style="width: 100%" placeholder="打印频率" v-model="time">
                                <template slot="append">秒</template>
                            </el-input>
                        </div>
                        <!-- 保存配置按钮 -->
                        <div class="button-group">
                            <el-button size="small" type="primary" v-if="isPrint" @click="printClick">自动打印</el-button>
                            <el-button size="small" type="success" v-else @click="printClick">关闭打印</el-button>
                            <el-button size="small" type="primary" :disabled="disabled" @click="manualPrint">手动打印</el-button>
                            <el-button size="small" :disabled="disabled" type="primary" @click="setUpClick">保存配置</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 下方表格区域 -->
        <div class="bottom-section">
            <div class="card table-card">
                <div class="card-header">
                    <h3>打印数据</h3>
                    <div class="table-info" v-if="returnData.list.length > 0">
                        共 {{ returnData.list.length }} 条数据
                    </div>
                </div>
                <div class="card-body">
                    <el-table class="table1" v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" stripe :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                              size="mini" ref="stockTable">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <template v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable">
                            <el-table-column align="center" v-if="tableValye.isShow==1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
                                             :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date'">
                                        <span v-if="scope.row[tableValye.entityField]">
                                            {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                                        </span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                    </span>
                                    <span v-else>
                                        {{scope.row[tableValye.entityField]}}
                                    </span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                    <div class="empty-state" v-else>
                        <el-empty description="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 对话框 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>

        <!-- 组件引用 -->
        <printPlan ref="printPlan" @close="closePrintPlan"></printPlan>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
import {
    getPrintDataById,
    printRecordAdd
} from "@/service/printApi.js";
export default {
    name: 'VoluntarilyPrint',
    data() {
        return {
            pageShowData: {},
            getRequestData: {},
            isPrint: true,
            time: 0,
            timeInterval: null,
            tableHeight: 0,
            returnData: {
                list: [],
            },
            disabled: false,
            printData: [],//打印模版列表
            selectPrint: [],//选择的打印模版
            userData: [],
            totalNum: 0,
            setUpId: "",
            selectedRows: [],
            //-------
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            sField: '',
            parentSearchData: {},
        }
    },
    computed: {},
    watch: {},
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        //查询数据
        searchData() {
            this.queryData()
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    if (key != 'page' && key != 'rows') {
                        this.$set(this.getRequestData, key, obj[key])
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //选择打印数据
        handleSelectionChange(val) {
            this.selectedRows = val
        },
        //关闭打印模版设计,刷新打印模版列表
        closePrintPlan() {
            this.queryPrintData()
        },
        //查询打印模版列表
        async queryPrintData() {
            const res = await this.$http.getPrintPlanById({ ids: [sessionStorage.getItem('printJurId')] })
            if (res.status == 200) {
                this.printData = res.result
            }
        },
        //查询打印配置
        async querySetUp() {
            const params = {

            }
            const res = await this.$http.woApplygetWoPrintConfig(params)
            console.log(res);

            if (res.status == 200) {
                if (res.result) {
                    this.setUpId = res.result.id
                    this.time = res.result.timeRange
                    this.selectPrint = res.result.printPlanId.split(',').map(item => Number(item))
                }
            }
        },
        //保存打印配置
        async setUpClick() {
            const params = {
                ormId: sessionStorage.getItem('ormId'),
                timeRange: this.time,
                printPlanId: this.selectPrint.join(','),
            }
            const res = await this.$http.woApplysetWoPrintConfig(params)
            console.log(res, "测试");
            if (res.status == 200) {
                this.$alert('保存成功', '提示', {
                    confirmButtonText: '确定',
                    callback: action => { }
                });
            } else {
                this.$alert(res.message, '提示', {
                    confirmButtonText: '确定',
                    callback: action => { }
                });
            }

        },
        //手动打印
        async manualPrint() {
            if (this.selectedRows.length == 0) {
                this.$message.warning("请选择要打印的商品")
                return
            }
            this.selectData = this.selectedRows
            await this.printBefore()//打印之前

        },
        //自动打印
        printClick() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
            } else {
                return
            }
            if (this.isPrint) {
                if (this.time < 60) {
                    this.$message.warning("打印频率不能小于60秒")
                    return
                }
                if (this.selectPrint.length == 0) {
                    this.$message.warning("请选择打印模版")
                    return
                }
            }
            this.isPrint = !this.isPrint
            if (!this.isPrint) {
                // 立即执行一次打印，然后再设置定时器
                this.queryData()
            } else {
                clearTimeout(this.timeInterval)
            }
            if (!this.isPrint) {
                this.disabled = true
            } else {
                this.disabled = false
            }
        },
        //查询数据
        async queryData(val) {
            const res = await this.$http.woApplyqueryWoBkeHis(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result
                if (this.returnData.list.length > 0) {
                    if (!val) {
                        if (!this.isPrint) {
                            this.selectData = this.returnData.list
                            await this.printBefore()//打印之前
                        }
                    }
                }
            }
            if (!val) {
                // 如果需要循环执行打印任务，在这里添加递归调用
                if (!this.isPrint) {
                    clearTimeout(this.timeInterval)
                    this.timeInterval = setTimeout(() => {
                        this.queryData()
                    }, this.time * 1000)
                }
            }
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                if (this.selectedRows.length != 1) {
                    this.$message.warning("请选择要打印的商品")
                    return
                }
                this.$refs.printPlan.openDia(this.selectedRows[0].wobkemId, "printData/suOrderBookkeepingZj", sessionStorage.getItem('printJurId'))
            } else {
                return
            }
        },
        async printBefore() {
            var arr = []
            this.userData=[]
            this.selectPrint.forEach(item => {
                arr.push(this.printData.find(print => print.printId == item))
            })
            console.log(arr)
            if (arr.length == 0) {
                return this.$message.warning("请维护打印模版")
            }
            this.totalNum = this.selectData.length * arr.length
            // 异步打印队列
            for (let index = 0; index < arr.length; index++) {
                const printTemplate = arr[index];
                console.log('开始打印模板:', printTemplate.printName);

                for (let index1 = 0; index1 < this.selectData.length; index1++) {
                    const printData = this.selectData[index1];
                    console.log('打印数据:', printData);

                    try {
                        // 等待打印任务完成
                        await this.printItem(printTemplate, printData);
                        console.log('打印任务完成:', printTemplate.printName, printData.bgmName);
                    } catch (error) {
                        console.error('打印失败:', error);
                        this.$message.error('打印失败: ' + error.message);
                        // 继续执行下一个打印任务
                    }
                }
            }

            console.log('所有打印任务完成');
        },

        // 打印单个项目
        printItem(template, data) {
            return new Promise((resolve, reject) => {
                try {
                    if (!data.wobkemId) {
                        throw new Error('缺少业务ID');
                    }

                    const params = {
                        id: data.wobkemId,
                        isPrint: 1,
                    };

                    // 调用 queryDataPrint 函数，并传入回调函数
                    this.queryDataPrint(params, template, (error) => {
                        if (error) {
                            console.error('打印失败:', error);
                            reject(error);
                        } else {
                            resolve();
                        }
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        // 获取打印数据并执行打印
        queryDataPrint(params, template, resolve) {
            var token = sessionStorage.getItem("token");
            if (!token) {
                return resolve(new Error('缺少认证 token'));
            }

            // 假设 getPrintDataById 是一个已定义的函数
            getPrintDataById(params, "printData/suOrderBookkeepingZj", token)
                .then(res => {
                    if (res.status === 200) {
                        var flag = false
                        var list = res.result
                        list.forEach(item => {
                            if (item.tableName == 'zj') {
                                if (item.rows.length == 0 && template.printName.includes('质检报告')) {
                                    flag = true
                                }
                                item.rows.forEach(row => {
                                    row.fileUrl = `${window.global_config.BASE_IMG_URL}/${row.fileUrl}`
                                })
                            }
                        })
                        this.totalNum--
                        if (flag) {
                            this.$message.warning(`单号：${params.id}-质检报告为空，不能打印`)
                        } else {
                            this.queryPrintNum(template, params, list)//打印次数
                        }
                        resolve()
                    } else {
                        throw new Error('获取打印数据失败: ' + res.message);
                    }
                })
                .catch(error => {
                    console.error('打印失败:', error);
                    resolve(error);
                });
        },
        async queryPrintNum(template, params1, list) {
            var token = sessionStorage.getItem("token");
            if (!token) {
                return resolve(new Error('缺少认证 token'));
            }
            const params = {
                printName: template.printName,
                printId: template.printId,
                businessId: params1.id,
                featuresName: "自动打印"
            }
            const res = await printRecordAdd(params, token)
            this.userData.push({
                list:list
            })
            console.log(this.userData, "打印数据")
            
            if (this.totalNum == 0) {
                this.selectData = []
                this.selectedRows = []
                this.queryData(true)
                this.$printSocketApi.previewReport(
                    this.userData,
                    template.printContent,
                    "print",
                    template.printName,
                    this.userData.length,//打印次数
                    template.printId,
                    'true',
                    'true'
                );
            }
        },
        //查询表格高度
        queryHeight() {
            var tableHeight = 0
            var topHeight = 0
            if (document.documentElement.querySelector(".page_content")) {
                tableHeight = document.documentElement.querySelector(".page_content").clientHeight
            }
            if (document.documentElement.querySelector(".page_content").querySelector(".top-layout")) {
                topHeight = document.documentElement.querySelector(".page_content").querySelector(".top-layout").clientHeight
            }
            console.log(tableHeight, topHeight)
            this.tableHeight = tableHeight - topHeight - 100
        },

    },
    created() {
        this.queryPrintData()//查询打印模版
        this.querySetUp()//查询配置设置
        this.getPageInfo()
        this.$nextTick(() => {
            this.queryHeight()
        })

    },
    beforeDestroy() {
        clearTimeout(this.timeInterval)
    },
    updated() { this.queryHeight() }, //生命周期 - 更新之后
}
</script>

<style scoped>
.page_content {
    padding: 15px;
    background-color: #f5f7fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* 顶部布局：左侧查询，右侧配置 */
.top-layout {
    display: flex;
    gap: 10px;
    margin-bottom: 0;
    align-items: stretch;
}

/* 左侧查询区域 */
.left-section {
    flex: 2;
    min-width: 500px;
    display: flex;
    flex-direction: column;
}

/* 右侧配置区域 */
.right-section {
    flex: 1;
    min-width: 350px;
    display: flex;
    flex-direction: column;
}

/* 卡片高度统一 */
.search-card,
.config-card {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* 右侧配置内容区域 */
.config-card .card-body {
    overflow-y: auto;
    min-height: 200px;
}

/* 下方表格区域 */
.bottom-section {
    flex: 1;
}

/* 卡片样式 */
.card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* 卡片头部 */
.card-header {
    background-color: #f8f9fa;
    padding: 5px 10px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

/* 卡片内容 */
.card-body {
    padding: 10px;
}

/* 表单组样式 */
.form-group {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.form-label {
    font-weight: 500;
    color: #606266;
    min-width: 80px;
}

/* 按钮组样式 */
.button-group {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

/* 选中的模板显示 */
.selected-templates {
    margin-left: 10px;
    color: #409eff;
    font-size: 12px;
    line-height: 1.4;
    width: 100%;
}

/* 表格信息 */
.table-info {
    font-size: 12px;
    color: #909399;
}

/* 空状态 */
.empty-state {
    padding: 60px 10px;
    text-align: center;
}

/* 表格样式优化 */
.table1 {
    border-collapse: collapse;
    width: 100%;
}

.el-table {
    transition: all 0.3s ease;
}

.el-table th {
    background-color: #f5f7fa !important;
    font-weight: 600 !important;
    color: #303133 !important;
}

.el-table tr:hover {
    background-color: #f5f7fa !important;
}

/* 按钮样式 */
.el-button {
    border-radius: 4px;
    transition: all 0.3s ease;
}

.el-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 输入框样式 */
.el-input {
    border-radius: 4px;
    transition: all 0.3s ease;
}

.el-input:hover .el-input__inner {
    border-color: #409eff;
}

/* 选择器样式 */
.el-select {
    transition: all 0.3s ease;
}

.el-select:hover .el-input__inner {
    border-color: #409eff;
}

/* 链接样式 */
a {
    transition: color 0.3s ease;
}

a:hover {
    color: #66b1ff;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
    .top-layout {
        flex-direction: column;
    }

    .left-section,
    .right-section {
        width: 100%;
        min-width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .page_content {
        padding: 10px;
    }

    .card-body {
        padding: 15px;
    }

    .form-group {
        flex-direction: column;
        align-items: flex-start;
    }

    .form-label {
        min-width: 100%;
        margin-bottom: 5px;
    }

    .selected-templates {
        margin-left: 0;
        margin-top: 10px;
    }

    .button-group {
        flex-wrap: wrap;
    }

    .card-header {
        padding: 10px 15px;
    }

    .card-header h3 {
        font-size: 14px;
    }
}
</style>